import React from "react";

import { AndroidInterstitial } from "../../../MVVM/Components/AndroidInterstitial";
import { ClipModal } from "../../../MVVM/Components/Modals/Clip";
import { ClipModals } from "../../../MVVM/Components/Modals/ClipModals";
import { CrossSitePromotion } from "../../../MVVM/Views/CrossSitePromotion";
import { DebugModal } from "../../../MVVM/Components/Modals/DebugModal";
import { DemoUploaderModal } from "../../../MVVM/Components/Modals/DemoUploader/";
import { ECrossSitePromotionType } from "../../../MVVM/@types";
import { AnnualUpsellModal } from "../Modals/AnnualUpsell";
import { ExpiredSubscriptionUpsell } from "../Modals/ExpiredSubscriptionUpsell";
import { CreatorCreditsAnnouncement } from "../Modals/CreatorCreditsAnnouncement";

import { Paywall } from "../../../MVVM/Components/Modals/Paywall";
import { RemoveConflictingCardsModal } from "../../../MVVM/Components/Modals/RemoveConflictingCards";
import { SignupModal } from "../../../MVVM/Components/Modals/Signup";
import { SimpleClipViewModal } from "../../../MVVM/Components/Modals/SimpleClipViewer";
import { StripePayStation } from "../../../MVVM/Components/Modals/StripePaystation";
import { StudioFTUEModal } from "../../../MVVM/Components/Modals/StudioFTUE";
import { TransitTimeModal } from "../../../MVVM/Components/Modals/TransitTime";
import { YoutubeUnavailable } from "../../../MVVM/Components/Modals";
import { SetRiotRegionModal } from "../Modals/SetRiotRegion";
import { Box } from "rebass/styled-components";
import { DiscordSupportModal } from "../Modals/DiscordSupport";
import { SignatureModal } from "../Modals/Signature";
import { GlobalStorageAddonModal } from "../Modals/StorageAddonModal/GlobalStorageAddonModal";

const ModalManager = () => (
  <Box id="modal-root">
    <AndroidInterstitial />
    <AnnualUpsellModal />
    <ExpiredSubscriptionUpsell />
    <ClipModal />
    <ClipModals />
    <CrossSitePromotion type={ECrossSitePromotionType.FirstLandTakeover} />
    <CreatorCreditsAnnouncement />
    <DebugModal />
    <DemoUploaderModal />
    <Paywall />
    <RemoveConflictingCardsModal />
    <SignupModal />
    <SimpleClipViewModal />
    <StripePayStation />
    <StudioFTUEModal />
    <TransitTimeModal />
    <YoutubeUnavailable />
    <SetRiotRegionModal />
    <SignatureModal />
    <DiscordSupportModal />
    <GlobalStorageAddonModal />
  </Box>
);

export { ModalManager };
